import { MARGINS_BLOCKS } from '@features/cms/const';
import theme from '@styles/theme';
export default {
  section: {
    display: 'flex',
    justifyContent: 'center',
    pt: MARGINS_BLOCKS[116],
    pb: MARGINS_BLOCKS[116],
    pl: ['20px'],
    pr: ['20px'],
    backgroundColor: theme.rawColors.lightGrey300,
    position: 'relative',
    zIndex: theme.zIndex.documentUp
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    'ol li, ul li, li p': {
      mb: theme.mbSection
    },
    'ol, ul': {
      listStylePosition: 'outside',
      ml: 16
    },
    'ol ol, ul ul': {
      ml: 16,
      mt: 16
    },
    maxWidth: ['100%', '100%', '478px', '903px'],
    'h2, h3, h4, h5': {
      mb: ['24px', '24px', '24px', '40px'],
      '&:last-child': {
        mb: 0
      }
    },
    'p, ul': {
      mb: ['6px', '6px', '12px', '12px'],
      '&:last-child': {
        mb: 0
      }
    }
  },
  contentContainer: {
    width: '100%'
  }
};